/**
 * Deburrs string by converting Latin-1 Supplement and Latin Extended-A letters
 * to basic Latin letters and removing combining diacritical marks.
 *
 * @param {string} string - The string to deburr.
 * @returns {string} Returns the deburred string.
 */
function deburr(string) {
  if (typeof string !== 'string') {
    return '';
  }

  // Use the Normalized Unicode Decomposition followed by removal of combining marks
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export { deburr };
